export interface INumberFormatter {
    locale: string;
}

export interface INumberOptions {
    decimals?: number;
}

export class NumberFormatter {
    private locale: string;

    constructor(config: INumberFormatter) {
        this.locale = config.locale;
    }

    public formatNumber = (amount: number, options: INumberOptions) => {
        const { decimals, ...rest } = options;

        return new Intl.NumberFormat(this.locale, {
            ...rest,
            maximumFractionDigits: decimals
        }).format(amount);
    };
}
